import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import {
  CoverageCheckupState,
  goToNextStep,
  updateCoverageCheckupState,
} from '../../../store/step';
import { Form, Formik } from 'formik';
import { SeparateInsurancePoliciesStepForm } from './SeparateInsurancePoliciesStepForm';
import { separateInsurancePoliciesSchema } from '../../schema/SeparateInsurancePoliciesSchema';
import { CardPadding, GrayCard, GrayCardHeader } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function SeparateInsurancePoliciesStep(): ReactElement {
  const dispatch = useDispatch();
  const {
    cellPhoneInsurancePossessed,
    cancerInsurancePossessed,
    accidentOrSicknessInsurancePossessed,
    accidentalDeathInsurancePossessed,
    petInsurancePossessed,
    homeWarrantyInsurancePossessed,
    mortgageLifeInsurancePossessed,
    noneOfThese,
  } = useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('other_insurances');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <>
      <GrayCard>
        <GrayCardHeader
          header="Last One: Separate Insurance Policies"
          subHeader=" These are policies you may have apart from the ones we've already
          mentioned."
        />
      </GrayCard>
      <CardPadding>
        <CardHeader header=" Do you have any separate insurance policies? Choose all that apply." />
        <Formik
          initialValues={{
            cellPhoneInsurancePossessed,
            cancerInsurancePossessed,
            accidentOrSicknessInsurancePossessed,
            accidentalDeathInsurancePossessed,
            petInsurancePossessed,
            homeWarrantyInsurancePossessed,
            mortgageLifeInsurancePossessed,
            noneOfThese,
          }}
          onSubmit={onSubmit}
          validationSchema={separateInsurancePoliciesSchema}
        >
          <Form ref={formRef}>
            <SeparateInsurancePoliciesStepForm />
          </Form>
        </Formik>
      </CardPadding>
    </>
  );
}

export { SeparateInsurancePoliciesStep };
